import React from 'react';
import { useParams } from 'react-router-dom';
import ClassifiedSupplierListing from './ClassifiedSupplierListing';

function ClassifiedSupplierPage() {
  const { id } = useParams(); // Extract the `id` from route parameters

  return (
    <>
      <ClassifiedSupplierListing classifiedId={id} />
    </>
  );
}

export default ClassifiedSupplierPage;
